import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const SalesChart = ({ data }) => {
  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    const grouped = {};

    data.forEach((item) => {
      if (!item.createdAt) return;
      const date = new Date(item.createdAt).toLocaleDateString("en-CA");

      if (!grouped[date]) {
        grouped[date] = {
          name: date,
          total: 0,
          paid: 0,
          due: 0,
        };
      }

      grouped[date].total += parseFloat(item.totalAmount) || 0;
      grouped[date].paid += parseFloat(item.paidAmount) || 0;
      grouped[date].due += parseFloat(item.dueAmount) || 0;
    });

    return Object.values(grouped).sort(
      (a, b) => new Date(a.name) - new Date(b.name),
    );
  }, [data]);

  if (!chartData.length) {
    return <p style={{ textAlign: "center" }}>No data available</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />

        <Line type="monotone" dataKey="total" stroke="#8884d8" name="Total" />
        <Line type="monotone" dataKey="paid" stroke="#82ca9d" name="Paid" />
        <Line type="monotone" dataKey="due" stroke="#ff7300" name="Due" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SalesChart;
